import React, { useEffect, useState } from 'react';
import { Formik } from "formik";
import percentagesValidation from './percentagesValidation';
import axios from 'axios';

export default function Percentages({ TipoUserLog,FetchData }) {
    const [percentages, setPercentages] = useState([]);

    const handleSubmit = async (values) => {
        try {
            const response = await axios.post(process.env.URLAPI + "saveOrUpdateMargenes", values);
            if(response.status === 200 || response.status === 201) getPorcentajes();
        } catch (err) {
            if (err.response.status === 400) window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response.data.message
            });
        }
    }

    const getPorcentajes = async () => {
        FetchData();
        const response = await axios.get(process.env.URLAPI + "getAllMargenes");
        setPercentages(response.data.data);
    }

    const getTipoUsuario = (tipoUsuario) => {
        let tipoUsuarioString = "";
        switch(tipoUsuario) {
            case 1:
                tipoUsuarioString = "Administrador";
                break;
            case 2:
                tipoUsuarioString = "Coperativa";
                break;
            case 3:
                tipoUsuarioString = "Corredor";
                break;
            default:
                break;
        }

        return tipoUsuarioString;
    }

    const deletePercentage= (id) => {
        window.Swal.fire({
            title: '¿Está seguro de eliminar el registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                $("#backdrop").show();
                try {
                    await axios.post(process.env.URLAPI + "deleteMargenes/" + id);
                    getPorcentajes();
                } catch(err) {
                    window.Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: err.response.data.message,
                    });
                }
                $("#backdrop").hide();
            }
        })
    }

    useEffect(() => {
        getPorcentajes();
    }, []);


    return (
        <Formik
            initialValues={{
                id: "",
                tipo_usuario_id: "",
                porcentaje: ""
            }}
            validationSchema={percentagesValidation}
            enableReinitialize="true"
            onSubmit={handleSubmit}>
            {({
                values,
                errors,
                handleChange,
                handleSubmit,
                resetForm,
                setValues
            }) => <div className="modal" id="percent" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Añadir nuevo usuario</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <form onSubmit={handleSubmit} autoComplete="off" >
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                            <div className={errors.nombre ? "form-group" : "form-group"}>
                                                {/* <label htmlFor="exampleInputEmail1">Tipo de usuario:</label>
                                                <input type="text" onChange={handleChange} value={values.tipoUsuario || ""} className={errors.nombre ? "form-control has-error" : "form-control"} name="nombre" id="nombre" autoComplete="none" />
                                                <span className="help-block">{errors.nombre}</span> */}
                                                <label htmlFor="exampleInputEmail1">Tipo:</label>
                                                <select name="tipo_usuario_id" id="tipo_usuario_id" className={errors.tipo_usuario_id ? "form-select has-error" : "form-select"} onChange={handleChange} value={values.tipo_usuario_id || ""} autoComplete="none">
                                                    <option value="">Seleccione una opción</option>
                                                    {/* <option value="1">Administrador</option> */}
                                                    {TipoUserLog == 1 ?
                                                        <>
                                                            <option value="2">Coperativa</option>
                                                            <option value="3">Corredor</option>
                                                        </> :
                                                        <>
                                                            <option value="3">Corredor</option>
                                                        </>}
                                                </select>
                                                <span className="help-block">{errors.tipo_usuario_id}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Porcentaje:</label>
                                                <input type="text" className={errors.porcentaje ? "form-control has-error" : "form-control"} onChange={handleChange} value={values.porcentaje || ""} name="porcentaje" id="porcentaje" autoComplete="none" />
                                                <span className="help-block">{errors.porcentaje}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" /* data-bs-dismiss="modal" */ onClick={() => resetForm()} >Nuevo</button>
                                    <button type='submit' className="btn btn-success">Guardar</button>
                                    {/*  <a onClick={()=>console.log("values",values)}>test etstate </a> */}
                                </div>
                            </form>
                            <div className="p-3">
                                <div className='table-responsive'>
                                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                        <thead>
                                            <tr>
                                                <th>Tipo de usuario</th>
                                                <th>Porcentaje</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {percentages && percentages.length == 0 && (
                                                <tr className='text-center'>
                                                    <td colSpan={7}>No hay usuarios registrados.</td>
                                                </tr>
                                            )}
                                            {percentages && percentages.map((percentage, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td>{getTipoUsuario(percentage.tipo_usuario_id)}</td>
                                                        <td>{percentage.porcentaje}</td>
                                                        <td className="text-center">
                                                            <button className="btn btn-success btn-circle btn-sm" onClick={() => setValues(percentage)} data-bs-toggle="tooltip" data-bs-placement="top" title="Editar usuario" ><i className="fa fa-file-signature"></i></button>
                                                            <button className="btn btn-danger btn-circle btn-sm" onClick={() => deletePercentage(percentage.id)} data-bs-toggle="tooltip" data-bs-placement="top" title="Desactivar usuario" ><i className="fa fa-trash"></i></button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </Formik>
    )
}
